import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  gap: ${({ theme }) => theme.spacing[4]}px;
`;

export const ListagemCondicionaisSenha = styled.div`
  display: flex;
  flex-direction: column;

  gap: ${({ theme }) => theme.spacing[2]}px;
`;
